export enum EditableState {
  Hovered = 'Hovered',
  Left = 'Left',
  Editing = 'Editing',
  Standard = 'Standard',
}
